import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";

import { useStyles } from "./ExaminationBody.css";
import { formatTime } from "../../../../Components/FormatTime/FormatTime";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";

class ExaminationBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      desktopColumn: [
        { name: "Subject" },
        { name: "Exam Date" },
        { name: "Start Time" },
        { name: "End Time" },
      ],
      mobileColumn: [
        { name: "Subject" },
        { name: "Exam Date" },
        { name: "Exam Time" },
      ],
    };
  }

  render() {
    const { classes, exam } = this.props;
    return (
      <div>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>{exam.examType}</div>
        <div className={classes.listitemRoot}>
          <ListItem divider style={{ marginRight: 10 }}>
            <div style={{ flexGrow: 1 }}>Start Date:</div>
            <div>{moment(exam.startDate).format("LL")}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>End Date:</div>
            <div>{moment(exam.endDate).format("LL")}</div>
          </ListItem>
        </div>
        {this.props.role === "Teacher" && (
          <div>
            <div className={classes.listitemRoot}>
              <ListItem divider style={{ marginRight: 10 }}>
                <div style={{ flexGrow: 1 }}>Class:</div>
                <div>{exam.className}</div>
              </ListItem>
              <ListItem divider>
                <div style={{ flexGrow: 1 }}>Section:</div>
                <div>{exam.section}</div>
              </ListItem>
            </div>
            <div className={classes.listitemRoot}>
              {exam.faculty && (
                <ListItem divider style={{ marginRight: 10 }}>
                  <div style={{ flexGrow: 1 }}>Faculty:</div>
                  <div>{exam.faculty}</div>
                </ListItem>
              )}
              {exam.group && (
                <ListItem divider>
                  <div style={{ flexGrow: 1 }}>Group:</div>
                  <div>{exam.group}</div>
                </ListItem>
              )}
            </div>
          </div>
        )}
        <div className={classes.sectionDesktop}>
          <TableContainer>
            <Table>
              <CustomTableHead column={this.state.desktopColumn} />
              <TableBody>
                {exam.subjects.length !== 0 &&
                  exam.subjects.map((subject, subjIndex) => (
                    <TableRow key={subjIndex}>
                      <TableCell align="center">{subject.name}</TableCell>
                      <TableCell align="center">
                        {moment(exam.date).format("LL")}
                      </TableCell>
                      {subject.startTime ? (
                        <TableCell align="center">
                          {formatTime(subject.startTime)}
                        </TableCell>
                      ) : (
                        <TableCell align="center">N/A</TableCell>
                      )}
                      {subject.endTime ? (
                        <TableCell align="center">
                          {formatTime(subject.endTime)}
                        </TableCell>
                      ) : (
                        <TableCell align="center">N/A</TableCell>
                      )}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className={classes.sectionMobile}>
          <TableContainer>
            <Table>
              <CustomTableHead column={this.state.mobileColumn} />
              <TableBody>
                {exam.subjects.length !== 0 &&
                  exam.subjects.map((subject, subjIndex) => (
                    <TableRow key={subjIndex}>
                      <TableCell align="center">{subject.name}</TableCell>
                      <TableCell align="center">
                        {moment(exam.date).format("LL")}
                      </TableCell>
                      <TableCell align="center">
                        {formatTime(subject.startTime)} -
                        {formatTime(subject.endTime)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(ExaminationBody);
